import { render, staticRenderFns } from "./DropdownActionsCases.vue?vue&type=template&id=5fb0082f&scoped=true"
import script from "./DropdownActionsCases.vue?vue&type=script&lang=js"
export * from "./DropdownActionsCases.vue?vue&type=script&lang=js"
import style0 from "./DropdownActionsCases.vue?vue&type=style&index=0&id=5fb0082f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb0082f",
  null
  
)

export default component.exports